// @flow
import React from 'react';

import { COLORS } from 'Components/utils/color/colors';

import { Text } from 'Components/frameworks/text/Text.jsx';

export type ProductFeatureDetailInformationProps = {
  className?: string,
  description: string,
  label?: string,
};

export function ProductFeatureDetailInformation(props: ProductFeatureDetailInformationProps) {
  const { className, description, label } = props;

  if (!description) {
    return null;
  }

  return (
    <article className={className}>
      {!!label && <div className="font-sans font-bold text-gray-darker text-sm">{label}: </div>}
      <Text color={COLORS.GRAY_DARKER} text={description} theme="text-sans-2" />
    </article>
  );
}
